import React from "react";

export const ContestWinningModalFormatter = (values) => {
    let str = ""

    if(values === "perRank")
    {
        str = "Rank"
    }
    else if(values === "perKill")
    {
        str = "Per Kill"
    }
    else if(values === "rank")
    {
        str = "Rank"
    }
    else if(values === "point base")
    {
        str = "Point Base"
    }

    return str
}